import { ReduxActionType } from 'types';

type ActionTypes = {
  FETCH_TOP_THREE_CLO_START: ReduxActionType;
  FETCH_TOP_THREE_CLO_SUCCESS: ReduxActionType;
  FETCH_TOP_THREE_CLO_FAILURE: ReduxActionType;
  FETCH_CLO_LISTING_START: ReduxActionType;
  FETCH_CLO_LISTING_SUCCESS: ReduxActionType;
  FETCH_CLO_LISTING_FAILURE: ReduxActionType;
  FETCH_CLO_DETAILS_START: ReduxActionType;
  FETCH_CLO_DETAILS_SUCCESS: ReduxActionType;
  FETCH_CLO_DETAILS_FAILURE: ReduxActionType;
  ADD_CLO_EVENT_START: ReduxActionType;
  ADD_CLO_EVENT_SUCCESS: ReduxActionType;
  ADD_CLO_EVENT_FAILURE: ReduxActionType;
  ADD_CLO_AS_FAVOURITE_START: ReduxActionType;
  ADD_CLO_AS_FAVOURITE_SUCCESS: ReduxActionType;
  ADD_CLO_AS_FAVOURITE_FAILURE: ReduxActionType;
  REMOVE_CLO_AS_FAVOURITE_START: ReduxActionType;
  REMOVE_CLO_AS_FAVOURITE_SUCCESS: ReduxActionType;
  REMOVE_CLO_AS_FAVOURITE_FAILURE: ReduxActionType;
  HIDE_CLO_START: ReduxActionType;
  HIDE_CLO_SUCCESS: ReduxActionType;
  HIDE_CLO_FAILURE: ReduxActionType;
  UNHIDE_CLO_START: ReduxActionType;
  UNHIDE_CLO_SUCCESS: ReduxActionType;
  UNHIDE_CLO_FAILURE: ReduxActionType;
  REFRESH_TOP_THREE_CLO_START: ReduxActionType;
};

export const CLOActionTypes: ActionTypes = {
  FETCH_TOP_THREE_CLO_START: '@@FETCH_TOP_THREE_CLO_START',
  FETCH_TOP_THREE_CLO_SUCCESS: '@@FETCH_TOP_THREE_CLO_SUCCESS',
  FETCH_TOP_THREE_CLO_FAILURE: '@@FETCH_TOP_THREE_CLO_FAILURE',
  FETCH_CLO_LISTING_START: '@@FETCH_CLO_LISTING_START',
  FETCH_CLO_LISTING_SUCCESS: '@@FETCH_CLO_LISTING_SUCCESS',
  FETCH_CLO_LISTING_FAILURE: '@@FETCH_CLO_LISTING_FAILURE',
  FETCH_CLO_DETAILS_START: '@@FETCH_CLO_DETAILS_START',
  FETCH_CLO_DETAILS_SUCCESS: '@@FETCH_CLO_DETAILS_SUCCESS',
  FETCH_CLO_DETAILS_FAILURE: '@@FETCH_CLO_DETAILS_FAILURE',
  ADD_CLO_EVENT_START: '@@ADD_CLO_EVENT_START',
  ADD_CLO_EVENT_SUCCESS: '@@ADD_CLO_EVENT_SUCCESS',
  ADD_CLO_EVENT_FAILURE: '@@ADD_CLO_EVENT_FAILURE',
  ADD_CLO_AS_FAVOURITE_START: '@@ADD_CLO_AS_FAVOURITE_START',
  ADD_CLO_AS_FAVOURITE_SUCCESS: '@@ADD_CLO_AS_FAVOURITE_SUCCESS',
  ADD_CLO_AS_FAVOURITE_FAILURE: '@@ADD_CLO_AS_FAVOURITE_FAILURE',
  REMOVE_CLO_AS_FAVOURITE_START: '@@REMOVE_CLO_AS_FAVOURITE_START',
  REMOVE_CLO_AS_FAVOURITE_SUCCESS: '@@REMOVE_CLO_AS_FAVOURITE_SUCCESS',
  REMOVE_CLO_AS_FAVOURITE_FAILURE: '@@REMOVE_CLO_AS_FAVOURITE_FAILURE',
  HIDE_CLO_START: '@HIDE_CLO_START',
  HIDE_CLO_SUCCESS: '@HIDE_CLO_SUCCESS',
  HIDE_CLO_FAILURE: '@HIDE_CLO_FAILURE',
  UNHIDE_CLO_START: '@UNHIDE_CLO_START',
  UNHIDE_CLO_SUCCESS: '@UNHIDE_CLO_SUCCESS',
  UNHIDE_CLO_FAILURE: '@UNHIDE_CLO_FAILURE',
  REFRESH_TOP_THREE_CLO_START: '@@REFRESH_TOP_THREE_CLO_START'
};

export interface CLOState {
  loadingTopThreeCLO?: boolean;
  topThreeCLO?: any;
  loadingCLODetails?: boolean;
  CLODetails?: any;
  loadingCLOListing?: boolean;
  CLOListing?: any;
  addingCLOEvent?: boolean;
  CLOEvent?: any;
  addingCLOAsFavourite?: boolean;
  addCLOAsFavourite?: any;
  removingCLOAsFavourite?: boolean;
  removeCLOAsFavourite?: any;
  hidingCLO?: boolean;
  unhidingCLO?: boolean;
  refreshCLO?: boolean;
}
